import {
  ContactDetailsAddressIcon,
  ContactDetailsEmailIcon,
  ContactDetailsNameIcon,
  ContactDetailsPhoneIcon,
  ContactDetailsWebsiteLink,
} from "../../../assets/icons";
import React from "react";
import getFixedUrl from "../../employer/helpers/getFixedUrl";
import { List } from "semantic-ui-react";

export function ListContactDetail({ isShow = true, icon, detail }) {
  if (isShow && detail !== "") {
    return (
      <List.Item>
        <List.Icon style={{ padding: 0 }}>{icon}</List.Icon>
        <List.Content style={{ padding: 0 }}>{detail}</List.Content>
      </List.Item>
    );
  } else {
    return null;
  }
}

export default function JobContactDetails({
  job,
  title = (
    <div className="body-heavy-text" style={{ margin: "0 0 15px 0" }}>
      Contact Details
    </div>
  ),
  style = {},
}) {
  return (
    <div style={{ ...style }}>
      {title}
      <List style={{ width: "90%" }}>
        <ListContactDetail
          icon={<ContactDetailsNameIcon />}
          detail={job.contactName}
        />
        <ListContactDetail
          icon={<ContactDetailsEmailIcon />}
          detail={job.contactEmail}
        />
        <ListContactDetail
          icon={<ContactDetailsPhoneIcon />}
          detail={job.phoneNumber}
        />
        {job.contactWebsiteUrl.url && (
          <ListContactDetail
            isShow={job.contactWebsiteUrl.url && !job.contactWebsiteUrl.isApply}
            icon={<ContactDetailsWebsiteLink />}
            detail={
              <a
                className="text-link"
                href={getFixedUrl(job.contactWebsiteUrl.url)}
                target="_blank"
                rel="noopener noreferrer"
              >
                {job.contactWebsiteUrl.url}
              </a>
            }
          />
        )}
        {job.locationType !== "Remote" && (
          <ListContactDetail
            isShow={true}
            icon={<ContactDetailsAddressIcon />}
            detail={
              job.multipleLocations.length > 0
                ? `${job.location.address} | ${job.multipleLocations
                    .map((loc) => loc.address)
                    .join(" | ")}`
                : job.location.address
            }
          />
        )}
      </List>
      {job.isInitialised && (
        <div className="details-item" style={{ marginTop: 16 }}>
          <span style={{ fontWeight: 800, fontSize: 14, paddingLeft: 7 }}>
            REF:{" "}
          </span>
          <span className="body-text">{job.refNumber}</span>
        </div>
      )}
    </div>
  );
}
